/**
 * 支票方式入金，目前仅 IRA 账户支持
 * 页面结构和转账汇款方式基本一致，但是页面的数据是从后端接口获取的
 */
import { useSWR } from '@tiger/swr';
import { Button, Form } from 'antd';
import { FC } from 'react';
import { $Formutil, withForm } from 'react-formutil';
import { useNavigate } from 'react-router-dom';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import { openNativeModal } from 'components/Modal';
import SwitchContributionWay from 'modules/Deposit/components/SwitchContributionWay';
import TaxLimit from 'modules/Deposit/components/TaxLimit';
import Item from 'modules/Deposit/Remittance/BankInfo/Item';
import { CheckGuideInfo } from 'modules/Deposit/type';
import successImg from 'static/images/icons/checked.svg';
import security from 'stores/security';
import { AccountCustomerTypeEnum } from 'types/user';
import API from 'utils/API';
import '../style.scss';

const Check: FC<{ $formutil: $Formutil }> = ({ $formutil }) => {
    const { $params } = $formutil;
    const navigate = useNavigate();
    const { data, isLoading, error, mutate } = useSWR<CheckGuideInfo>(API.TRADE.deposit.getCheckInfo(), {
        dataChain: resp => resp.data
    });

    const handleDone = () => {
        openNativeModal({
            maskClosable: true,
            closable: true,
            width: '100%',
            className: 'deposit-go-notice-modal',
            component: props => (
                <div>
                    <img className="modal-icon" src={successImg} alt="" />
                    <h3 className="modal-title">{__('感谢您的支持！')}</h3>
                    <p className="modal-subtitle">{__('我们会尽快处理您的入金')}</p>
                    <Button
                        className="modal-btn"
                        onClick={() => {
                            props.close();
                            navigate('../check-notice');
                        }}>
                        {__('上传转账详情')}
                    </Button>
                    <p className="modal-desc">{__('您可以在此上传您的转账详情，以避免意外的延迟。')}</p>
                </div>
            )
        }).result.catch(() => {});
    };

    const render = () => {
        if (isLoading) {
            return <Loading />;
        }

        if (error && !data) {
            return <ErrorBox error={error} onClick={() => mutate()} />;
        }

        return (
            <Form layout="vertical" className="remittance-bank-info list check" onFinish={handleDone}>
                <TaxLimit />
                <div>{__('Mail the check to the following address')}</div>
                <div>
                    <Item label={__('Beneficiary name')} value={data!.beneficiaryName} />
                    <Item label={__('Address')} value={data!.mailAddress} />
                    <Item
                        label={__('Memo')}
                        value={`${$params.tax_year} IRA Contribution BRID *${security.currentAccount?.ibAccount}*`}
                    />
                </div>
                <Button className="btn-important" type="primary" block htmlType="submit">
                    {__('Done')}
                </Button>
            </Form>
        );
    };

    const getTitle = () => {
        switch (security.currentAccount!.customerType) {
            case AccountCustomerTypeEnum.IRA_ROTH:
                return __('Contribute to your Roth IRA via check');
            case AccountCustomerTypeEnum.IRA_TRADITIONAL:
                return __('Contribute to your Traditional IRA via check');
            case AccountCustomerTypeEnum.IRA_ROLLOVER:
                return __('Contribute to your Rollover IRA via check');
            default:
                return __('通过支票汇款入金');
        }
    };

    return (
        <div className="deposit-remittance-root">
            <h3 className="main-title">
                <span>{getTitle()}</span>
                <SwitchContributionWay currentWay="check" />
            </h3>
            {render()}
        </div>
    );
};

export default withForm(Check);
